import React, { FC, useEffect } from 'react';
import { create } from 'zustand';

export interface DragAndDropStore {
  dropped: string[];
  lastId: string;
  setDropped: (dropped: string[]) => void;
  setLastId: (lastId: string) => void;
}

const _useDragAndDropStore = create<DragAndDropStore>(set => ({
  dropped: [],
  lastId: '',
  setDropped: dropped => set({ dropped }),
  setLastId: lastId => set({ lastId })
}));

export const DragAndDropProvider: FC = ({ children }) => {
  useEffect(() => {
    useDragAndDropStore.setState({ dropped: [], lastId: '' });
  }, []);

  return <>{children}</>;
};

export const useDragAndDropStore = _useDragAndDropStore;
